import { useRoutes, Navigate, useParams } from "react-router-dom";
import Clients from "../apsales/Clients";
import Projects from "../apsales/Projects";
import Products from "../apsales/Products";
import AddProduct from "../apsales/Products/Add";
import EditProduct from "../apsales/Products/Edit";
import AddCompany from "../apsales/AddCompany";
import AddEditCompany from "../apsales/Company/AddEditCompany"; 
import Login from "../apsales/Login";
import ProtectedRoute from "../components/ProtectedRoute";
import RoleGate from "../components/RoleGate";
import Layout from "../themes";
import AddProject from "@/apsales/AddProject";
import EditProject from "@/apsales/EditProject";
import Attendance from "@/apsales/Attendance";
import Users from "@/apsales/Users";
import AddUser from "@/apsales/Users/Add";
import EditUser from "@/apsales/Users/Edit";
import ProductGroup from "@/apsales/ProductGroup";
import AddProductGroup from "@/apsales/ProductGroup/Add";
import EditProductGroup from "@/apsales/ProductGroup/Edit";
import ProductType from "@/apsales/ProductType";
import AddProductType from "@/apsales/ProductType/Add";
import EditProductType from "@/apsales/ProductType/Edit";
import PackType from "@/apsales/PackType";
import AddPackType from "@/apsales/PackType/Add";
import EditPackType from "@/apsales/PackType/Edit";
import Outlets from "../apsales/Outlets";
import AddOutlet from "../apsales/Outlets/Add";
import EditOutlet from "../apsales/Outlets/Edit";
import ImportOutlets from "../apsales/Outlets/import";
import OutletGroup from "../apsales/OutletGroup";
import AddOutletGroup from "../apsales/OutletGroup/Add";
import EditOutletGroup from "../apsales/OutletGroup/Edit";
import OutletType from "../apsales/OutletType";
import AddOutletType from "../apsales/OutletType/Add";
import EditOutletType from "../apsales/OutletType/Edit";
import OutletCategory from "../apsales/OutletCategory";
import AddOutletCategory from "../apsales/OutletCategory/Add";
import EditOutletCategory from "../apsales/OutletCategory/Edit";
import EmpCategory from "../apsales/EmpCategory";
import AddEmpCategory from "../apsales/EmpCategory/Add";
import EditEmpCategory from "../apsales/EmpCategory/Edit"
import CoDept from "../apsales/CompanyDepartment";
import AddCoDept from "../apsales/CompanyDepartment/Add";
import EditCoDept from "../apsales/CompanyDepartment/Edit";
import Teams from "../apsales/Teams";
import AddTeam from "../apsales/Teams/Add";
import EditTeam from "../apsales/Teams/Edit";
import TeamCategories from "../apsales/TeamCategory";
import AddTeamCategory from "../apsales/TeamCategory/Add";
import EditTeamCategory from "../apsales/TeamCategory/Edit";
import Regions from "../apsales/Region";
import AddRegion from "../apsales/Region/Add";
import EditRegion from "../apsales/Region/Edit";
import Sales from "../apsales/Projects/Sales";
import Pricing from "../apsales/Projects/Pricing";
import Stock from "../apsales/Projects/Stock";
import MasterData from "../apsales/Projects/MasterData";
import OOSThreshold from "../apsales/Projects/OOSThreshold";
import StockBatch from "../apsales/Projects/StockBatch";
import WorkplannerStatus from "../apsales/Projects/WorkplannerStatus";
import MerchandiserProducts from "../apsales/Projects/MerchandiserProducts";
import Merchandising from "../apsales/Projects/Merchandising";
import Survey from "../apsales/Projects/Survey";
import ProjectSettings from "../apsales/Projects/ProjectSettings";
import AssignUser from "../apsales/Teams/AssignUser";
import AssignOutlet from "../apsales/Teams/AssignOutlet";
import AssignProduct from "../apsales/Teams/AssignProduct";

function OOSReportsRedirect() {
  const { projectId } = useParams<{ projectId: string }>();
  if (!projectId) return <Navigate to="/projects" replace />;
  return <Navigate to={`/projects/${projectId}/oos`} replace />;
}

function ProjectDashboardRedirect() {
  const { projectId } = useParams<{ projectId: string }>();
  if (!projectId) return <Navigate to="/projects" replace />;
  return <Navigate to={`/projects/${projectId}/sales`} replace />;
}

function Router() {
  const routes = [
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/",
      element: <Navigate to="/login" replace />,
    },
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [

        // CLIENTS ----------------------------------------------- //
        {
          path: "clients",
          element: (
            <RoleGate allow={["SUPERADMIN"]}>
              <Clients />
            </RoleGate>
          ),
        },

        // COMPANIES --------------------------------------------- //
        {
          path: "add-company",
          element: (
            <RoleGate allow={["SUPERADMIN"]}>
              <AddCompany />
            </RoleGate>
          ),
        },
        {
          path: "companies/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN"]}>
              <AddEditCompany />
            </RoleGate>
          ),
        },

        // PROJECTS ----------------------------------------------- //
        {
          path: "projects",
          element: (
            <RoleGate allow={["SUPERADMIN","ADMIN"]}>
              <Projects />
            </RoleGate>
          ),
        },
        {
          path: "projects/add",
          element: (
            <RoleGate allow={["ADMIN"]}>
              <AddProject />
            </RoleGate>
          ),
        },
        {
          path: "projects/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditProject />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/sales",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <Sales />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/dashboard",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <ProjectDashboardRedirect />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/pricing",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <Pricing />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/stock",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <Stock />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/attendance",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <Attendance />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/master-data",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <MasterData />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/oos",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <OOSThreshold />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/reports",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <OOSReportsRedirect />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/stock-batch",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <StockBatch />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/workplanner-status",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <WorkplannerStatus />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/merchandiser-products",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <MerchandiserProducts />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/merchandising",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <Merchandising />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/survey",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <Survey />
            </RoleGate>
          ),
        },
        {
          path: "projects/:projectId/project-settings",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <ProjectSettings />
            </RoleGate>
          ),
        },

        // PRODUCTS ------------------------------------------------ //
        {
          path: "products",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <Products />
            </RoleGate>
          ),
        },
        {
          path: "products/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddProduct />
            </RoleGate>
          ),
        },
        {
          path: "products/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditProduct />
            </RoleGate>
          ),
        },
        {
          path: "product-groups",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <ProductGroup />
            </RoleGate>
          ),
        },
        {
          path: "product-groups/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddProductGroup />
            </RoleGate>
          ),
        },
        {
          path: "product-groups/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditProductGroup />
            </RoleGate>
          ),
        },
        {
          path: "product-types",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <ProductType />
            </RoleGate>
          ),
        },
        {
          path: "product-types/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddProductType />
            </RoleGate>
          ),
        },
        {
          path: "product-types/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditProductType />
            </RoleGate>
          ),
        },
        {
          path: "pack-types",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <PackType />
            </RoleGate>
          ),
        },
        {
          path: "pack-types/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddPackType />
            </RoleGate>
          ),
        },
        {
          path: "pack-types/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditPackType />
            </RoleGate>
          ),
        },

        // OUTLETS ----------------------------------------------- //
        {
          path: "outlets",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <Outlets />
            </RoleGate>
          ),
        },
        {
          path: "outlets/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddOutlet />
            </RoleGate>
          ),
        },
        {
          path: "outlets/import",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <ImportOutlets />
            </RoleGate>
          ),
        },
        {
          path: "outlets/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditOutlet />
            </RoleGate>
          ),
        },
        {
          path: "outlet-groups",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <OutletGroup />
            </RoleGate>
          ),
        },
        {
          path: "outlet-groups/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddOutletGroup />
            </RoleGate>
          ),
        },
        {
          path: "outlet-groups/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditOutletGroup />
            </RoleGate>
          ),
        },
        {
          path: "outlet-types",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <OutletType />
            </RoleGate>
          ),
        },
        {
          path: "outlet-types/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddOutletType />
            </RoleGate>
          ),
        },
        {
          path: "outlet-types/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditOutletType />
            </RoleGate>
          ),
        },
        {
          path: "outlet-categories",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <OutletCategory />
            </RoleGate>
          ),
        },
        {
          path: "outlet-categories/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddOutletCategory />
            </RoleGate>
          ),
        },
        {
          path: "outlet-categories/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditOutletCategory />
            </RoleGate>
          ),
        },

        // USERS --------------------------------------------------- //
        {
          path: "users",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <Users />
            </RoleGate>
          ),
        },
        {
          path: "users/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddUser />
            </RoleGate>
          ),
        },
        {
          path: "users/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditUser />
            </RoleGate>
          ),
        },
        {
          path: "employee-categories",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EmpCategory />
            </RoleGate>
          ),
        },
        {
          path: "employee-categories/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddEmpCategory />
            </RoleGate>
          ),
        },
        {
          path: "employee-categories/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditEmpCategory />
            </RoleGate>
          ),
        },
        {
          path: "co-departments",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <CoDept />
            </RoleGate>
          ),
        },
        {
          path: "co-departments/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddCoDept />
            </RoleGate>
          ),
        },
        {
          path: "co-departments/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditCoDept />
            </RoleGate>
          ),
        },

        // TEAMS ----------------------------------------------- //
        {
          path: "teams",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <Teams />
            </RoleGate>
          ),
        },
        {
          path: "teams/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddTeam />
            </RoleGate>
          ),
        },
        {
          path: "teams/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditTeam />
            </RoleGate>
          ),
        },
        {
          path: "regions",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <Regions />
            </RoleGate>
          ),
        },
        {
          path: "regions/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddRegion />
            </RoleGate>
          ),
        },
        {
          path: "regions/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditRegion />
            </RoleGate>
          ),
        },
        {
          path: "team-categories",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <TeamCategories />
            </RoleGate>
          ),
        },
        {
          path: "team-categories/add",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AddTeamCategory />
            </RoleGate>
          ),
        },
        {
          path: "team-categories/:id/edit",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <EditTeamCategory />
            </RoleGate>
          ),
        },
        {
          path: "teams/:id/assign-user",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AssignUser />
            </RoleGate>
          ),
        },
        {
          path: "teams/:id/assign-outlet",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AssignOutlet />
            </RoleGate>
          ),
        },
        {
          path: "teams/:id/assign-product",
          element: (
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
              <AssignProduct />
            </RoleGate>
          ),
        },
      ],
    },
  ];

  return useRoutes(routes);
}

export default Router;
